// Map a node kind to the cockpit tab where that node "lives". Used
// so chat-citation chips and Why-engine evidence don't just focus
// the Why-engine — they also send the user to the visual surface
// where the node is shown.

import type { NodeKind } from "../types/ontology";

export type CockpitTab =
  | "rooms" | "catalog" | "inspiration" | "rules" | "library" | "memory" | "agent" | "graph" | "data";

export function tabForKind(kind: NodeKind): CockpitTab {
  switch (kind) {
    case "Room":
    case "Zone":
    case "Placement":
      return "rooms";
    case "SKU":
    case "Material":
    case "Vendor":
    case "BudgetLine":
      return "catalog";
    case "Intent":
    case "Style":
      return "inspiration";
    case "Rule":
      return "rules";
    case "MemoryCard":
      return "memory";
    case "Approval":
    case "Milestone":
    case "Alert":
    case "Project":
    case "Client":
    default:
      return "graph";
  }
}
